import React, { useState } from 'react'

import FormikCheckboxField from 'common/components/dataEntry/formik/FormikCheckboxField'

import { Button, Modal } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { formatMoney } from 'common/moneyFormatter'

import './styles.less'

type ApproveReimbursementsDueModalProps = {
  translate: (key: string) => string
  visible: boolean
  approveLoading: boolean
  onCancel: () => void
  onApprove: (downloadCsv: boolean) => void
  companyName: string
  scheduled: Date
  reimbursementMethod: string
  reimbursementsDue: EmployeeSummary[]
}

type EmployeeSummary = {
  employeeFullName: string
  amountToReimburse: number
}

const ApprovePerksReimbursementsDueModal: React.FC<ApproveReimbursementsDueModalProps> = ({
  translate,
  visible,
  approveLoading,
  onCancel,
  onApprove,
  companyName,
  scheduled,
  reimbursementMethod,
  reimbursementsDue,
}) => {
  const [downloadCsv, setDownloadCsv] = useState(false)
  const footer = [
    <Button key="cancel" type="default" htmlType="button" onClick={onCancel} disabled={approveLoading}>
      {translate('general.cancel')}
    </Button>,
    <Button
      key="approve"
      type="primary"
      htmlType="button"
      onClick={() => onApprove(downloadCsv)}
      icon="far fa-check-circle"
      loading={approveLoading}
      disabled={approveLoading}
    >
      {translate('general.approve')}
    </Button>,
  ]

  return (
    <Modal
      title={`${translate('general.approve')}?`}
      closable={!approveLoading}
      visible={visible}
      footer={footer}
      onCancel={onCancel}
      destroyOnClose
    >
      <div className="approve_perks_reimbursements_due_modal">
        <h6 className="acceptance_description pb-16">
          {translate('admin-dashboard.reimbursements.perks-reimbursements-due.acceptance-description')
            .replace('[COMPANYNAME]', companyName)
            .replace('[SCHEDULED]', parseZoneFormat(scheduled))
            .replace('[REIMBURSEMENTMETHOD]', reimbursementMethod)}
        </h6>
        {reimbursementsDue.map((item, index) => {
          return (
            <div key={index} className="employee_summary pt-8 pb-8">
              <h6 className="employee_full_name">{item.employeeFullName}</h6>
              <h6 className="amount_to_reimburse">{formatMoney(item.amountToReimburse)}</h6>
            </div>
          )
        })}
        <div className="download_csv pt-8 pb-8">
          <FormikCheckboxField
            name="downloadCsv"
            onChange={(e: any) => setDownloadCsv(e.target.checked)}
            checked={downloadCsv}
          />
          <label htmlFor="downloadCsv" className="pl-8">
            {translate('admin-dashboard.reimbursements.reimbursements-due.download-csv')}
          </label>
        </div>
      </div>
    </Modal>
  )
}

export default ApprovePerksReimbursementsDueModal
